import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getSorting, stableSort } from '../../../util/TableUtils'
import { useQueryParams } from '../../../util/utils'
import EnhancedTableHead from '../../components/TableHead'
import { usePermissions } from '../../../hooks/usePermission'
import {
  fetchServiceCategory,
  remove,
  updateActiveToOrcament,
} from '../ServiceCategoryActions'
import { StyledTableCellBody } from '../../../components/hooks/BaseTableComponents'
import { Box, Grid } from '@material-ui/core'
import colors from '../../../assets/colors'
import Icon from '@mdi/react'
import { mdiDelete, mdiNoteEditOutline } from '@mdi/js'
import { CustomSwitch } from '../../../components/ui/custom-switch'
import ModalServiceCategory from './Modal'
import Pagination from '../../../components/hooks/BasePagination'
import { useHistory, useLocation } from 'react-router-dom'
import BasePopUp from '../../../components/hooks/BasePopUp'

function createData(
  id,
  name,
  status,
  color,
  cashback_conversion,
  active_to_orcament,
  editable
) {
  return {
    id,
    name,
    status,
    color,
    cashback_conversion,
    active_to_orcament,
    editable,
  }
}

const BASE_HEAD_CELLS = [
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Nome',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Cor',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Ações',
    align: 'center',
  },
]

const ORCAMENTO_HEAD_CELL = {
  id: 'active_to_orcament',
  numeric: true,
  disablePadding: false,
  label: 'Módulo Orçamento',
  align: 'center',
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableStickHeader: {
    maxHeight: 'calc(100vh - 200px)',
    marginTop: '1.5em',
  },
  status: {
    textAlign: 'center',
    fontSize: '14p',
    borderRadius: '10px',
    padding: '4px 16px',
    maxWidth: '80px',
    backgroundColor: colors.graylight,
    color: '#000',
  },
  statusAtivo: {
    color: '#FFFF',
    backgroundColor: colors.secondary,
  },
  retangleColor: {
    width: '18px',
    height: '18px',
    borderRadius: '2px',
  },
}))

export const List = ({ classes }) => {
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canUpdate, canDelete, canCreate } = usePermissions()
  const items = useSelector(state => state.serviceCategory.items)
  const meta = useSelector(state => state.serviceCategory.meta)

  const styles = useStyles()

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('value')
  const [selected, setSelected] = useState([])

  const [open, setOpen] = useState(false)
  const [editId, setEditId] = useState()

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [categoryToDelete, setCategoryToDelete] = useState(null)

  const showOrcamentoColumn = canCreate(
    'modulo-orcamento-categorias-servico',
    permissionUser
  )
  const headCells = showOrcamentoColumn
    ? [
        ...BASE_HEAD_CELLS.slice(0, -1),
        ORCAMENTO_HEAD_CELL,
        BASE_HEAD_CELLS[BASE_HEAD_CELLS.length - 1],
      ]
    : BASE_HEAD_CELLS

  const handleClose = () => {
    setOpen(!open)
  }

  const rows = []

  items.map(item => {
    rows.push(
      createData(
        item.id,
        item.name,
        item.status_text,
        item.color,
        item.cashback_conversion,
        item.active_to_orcament,
        item.editable
      )
    )
  })

  const handleToggleOrcament = row => {
    dispatch(updateActiveToOrcament(row.id, !row.active_to_orcament))
  }

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isDesc ? 'asc' : 'desc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const onMovePage = (event, newPage) => {
    const data = { ...filters, page: newPage }
    handleSubmit(data)
  }

  const handleOpenDeleteModal = (id = null) => {
    if (id) {
      setCategoryToDelete(id)
    }
    setOpenDeleteModal(!openDeleteModal)
  }

  const handleConfirmDelete = () => {
    if (categoryToDelete) {
      dispatch(remove(categoryToDelete))
      dispatch(
        fetchServiceCategory({
          ...filters,
          page: filters?.page || 1,
          rows: filters?.rows || 10,
        })
      )
      setOpenDeleteModal(false)
      setCategoryToDelete(null)
    }
  }

  return (
    <>
      <TableContainer className={classes.tableStickHeader}>
        <Table
          className={classes.table}
          aria-labelledby="Tabela de Categorias de Serviços"
        >
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
            headCells={headCells}
            renderFirstTH={false}
          />
          <TableBody>
            {stableSort(rows, getSorting(order, orderBy)).map(row => {
              return (
                <TableRow hover tabIndex={-1} key={row.id}>
                  {/* <StyledTableCellBody padding="checkbox" /> */}
                  <StyledTableCellBody>{row.name}</StyledTableCellBody>
                  <StyledTableCellBody>
                    {row.status.toLowerCase() === 'ativo' ? (
                      <Box className={[styles.status, styles.statusAtivo]}>
                        {row.status}
                      </Box>
                    ) : (
                      <Box className={styles.status}>{row.status}</Box>
                    )}
                  </StyledTableCellBody>
                  <StyledTableCellBody>
                    <Grid container direction="row" spacing={1}>
                      <Grid item>
                        <Box
                          className={styles.retangleColor}
                          style={{ backgroundColor: `${row.color}` }}
                        />
                      </Grid>

                      <Grid item>{row.color}</Grid>
                    </Grid>
                  </StyledTableCellBody>

                  {showOrcamentoColumn && (
                    <StyledTableCellBody align="center">
                      <CustomSwitch
                        checked={!!row.active_to_orcament}
                        onChange={() => handleToggleOrcament(row)}
                      />
                    </StyledTableCellBody>
                  )}

                  <StyledTableCellBody align="center">
                    {row.editable && (
                      <>
                        {canUpdate('categorias-servico', permissionUser) && (
                          <IconButton
                            aria-label="edit"
                            onClick={() => {
                              handleClose()

                              setEditId(row.id)
                            }}
                          >
                            <Icon path={mdiNoteEditOutline} size={1} />
                          </IconButton>
                        )}
                        {canDelete('categorias-servico', permissionUser) && (
                          <IconButton
                            onClick={() => handleOpenDeleteModal(row.id)}
                          >
                            <Icon path={mdiDelete} size={1} />
                          </IconButton>
                        )}
                      </>
                    )}
                  </StyledTableCellBody>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={meta?.per_page}
        rows={meta?.total}
        page={meta?.current_page}
        from={meta?.from}
        to={meta?.to}
        handleChangePage={onMovePage}
      />

      <ModalServiceCategory
        isEdit
        id={editId}
        open={open}
        handleClose={handleClose}
      />

      <BasePopUp
        open={openDeleteModal}
        type="error"
        title="Excluir Categoria de Serviço"
        message="Deseja realmente excluir esta categoria de serviço?"
        handleOpen={handleOpenDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  )
}
